export const QuestionType = Object.freeze({
  short: 'SHORT',
  multiChoiceV2: 'MULTI_CHOICE_V2',
  multiChoice: 'MULTI_CHOICE',
  multiChoiceText: 'MULTI_CHOICE_TEXT',
  multiChoiceImage: 'MULTI_CHOICE_IMAGE',
  multiAnswer: 'MULTI_ANSWER',
  multiAnswerAlphabet: 'MULTI_ANSWER_ALPHABET',
  spoken: 'SPOKEN',
  sentenceSort: 'SENTENCE_SORT',
  matchingParent: 'MATCHING_PARENT',
  tableParent: 'TABLE_PARENT',
  tableChild: 'TABLE_CHILD',
  tableMultiParent: 'TABLE_MULTI_PARENT',
  tableMultiRow: 'TABLE_MULTI_ROW_PARENT',
  tableMultiRowChild: 'TABLE_MULTI_ROW_CHILD',
  multiChoicePlaybook: 'MULTI_CHOICE_PLAYBOOK',
  multiAnswerPlaybook: 'MULTI_ANSWER_PLAYBOOK',
  openEndedOral: 'OPEN_ENDED_ORAL',
  openEndedWriting: 'OPEN_ENDED_WRITING',
});

export const SUBJECTIVE_QUESTION_TYPES = Object.freeze([
  QuestionType.short,
  QuestionType.spoken,
  QuestionType.tableChild,
  QuestionType.tableMultiRowChild,
  QuestionType.openEndedOral,
  QuestionType.openEndedWriting,
]);

export const SUBJECTIVE_QUESTION_TYPES_SET = new Set(SUBJECTIVE_QUESTION_TYPES);
